module.exports = __webpack_public_path__ + "img/category-others.cfc200ec.svg";